export enum WarningsDialogActions {
    GO_BACK_AND_CORRECT_IT = 'go back and correct it',
    PROCEED = 'proceed',
}
